import React from 'react';
import { Text4 } from '../../../styles';


export const bulkOperationsTypeMaster = {
    transfer: "Bulk Transfer",
    beneficiary: "Bulk Create Beneficiary",
    instacollect_order: "InstaCollect Order",
    penny_drop: "Bulk Penny Drop",
    vendor: "Bulk Create Vendors",
    vendor_invoice: "Bulk Create Vendor Invoices",
    advanced_penny_drop: "Bulk Advanced Penny Drop",
    payout_link:"Bulk Create Payout Links",
}

export const bulkOperationsTemplateMaster = {
    transfer: "Easebuzz - Bulk Transfer Template.xlsx",
    beneficiary: "Easebuzz - Bulk Create Beneficiary Template.xlsx",
    instacollect_order: "Easebuzz - InstaCollect Order Template.xlsx",
    penny_drop: "Easebuzz - Bulk Account Validation Template.xlsx",
    vendor: "Easebuzz - Bulk Create Vendors Template.xlsx",
    vendor_invoice: "Easebuzz - Bulk Create Vendor Invoices Template.xlsx",
    advanced_penny_drop: "Easebuzz - Bulk Advanced Penny Drop Template.xlsx",
    payout_link:"Easebuzz - Bulk Payout Links Template.xlsx",
}

export const bulkErrorColumns = [{
    title: "Field",
    key: "field",
    width: "15%",
    render: (record) => <Text4>{record.field}</Text4>
}, {
    title: "Error Category",
    key: "category",
    width: "15%",
    render: (record) => <Text4>{record.category}</Text4>
}, {
    title: "Sheet Row Numbers",
    key: "row_numbers",
    width: "20%",
    render: (record) => <Text4>{record.row_numbers}</Text4>
}, {
    title: "Error Message",
    key: "message",
    width: "50%",
    render: (record) => <Text4>{record.message}</Text4>
}];

export const bulkFieldsMaster = {
    beneficiary_name: "Beneficiary Name",
    account_number: "Account Number",
    account_ifsc: "IFSC Code",
    upi_handle: "UPI Handle",
    unique_request_number: "Unique Request Number",
    amount: "Amount",
    payment_mode: "Payment Mode",
    email: "Email ID",
    phone: "Phone Number",
    narration: "Narration",
    account_details: "Account Details",
    udf1: "UDF1",
    udf2: "UDF2",
    udf3: "UDF3",
    udf4: "UDF4",
    udf5: "UDF5",
    customer_name: "Customer Name",
    customer_phone: "Customer Phone Number",
    customer_email: "Customer Email ID",
    amount: "Amount",
    order_amount: "Order Amount",
    per_transaction_amount: "Per Transaction Amount",
    notification_cycle_type: "Notification Cycle Type",
    notify_customer_on_create: "Notify Customer on create",
    allowed_collection_modes: "Collection Modes",
    name: "Vendor Name",
    account_name: "Account Name",
    account_number: "Account Number",
    vendor_id: "Vendor ID",
    invoice_number: "Invoice Number",
    description: "Description",
    gross_amount: "Gross Amount",
    gst_amount: "GST Amount",
    tds_percentage: "TDS Percentage",
    initiate_payment: "Initiate Payment",
    invoice_date: "Invoice Date",
    due_date: "Due Date",
    expiry_date: "Expiry Date",
    account_holder_name: "Account Holder Name",
    percentage_match_threshold: "Percentage Match Threshold",
    scheduled_for: "Scheduled For",
    url: "Webhook URL",
    max_attempts: "Max Attempts",
    interval: "Interval Value OR Interval Unit",
    interval_value: "Interval Value",
    interval_unit: "Interval Unit"
};

export const BATCHTYPES = [
    { key: "Penny Drop", value: "penny_drop", required_setting: "ebav", required_permission: "BULK_PENNY_DROP" },
    { key: "Advanced Penny Drop", value: "advanced_penny_drop", required_setting: "ebavwfc", required_permission: "BULK_ADVANCED_PENNY_DROP" }
]


export const webhookErrorColumns = [{
    title: "Event",
    key: "label",
    width: "15%",
    render: (record) => <Text4>{record.label}</Text4>
}, {
    title: "Field",
    key: "field",
    width: "15%",
    render: (record) => <Text4>{record.field}</Text4>
}, {
    title: "Error Category",
    key: "category",
    width: "15%",
    render: (record) => <Text4>{record.category}</Text4>
}, {
    title: "Error Message",
    key: "message",
    width: "50%",
    render: (record) => <Text4>{record.message}</Text4>
}];